import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import css from './ScrollSnapper.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

function scrollSnapper(ChildComponent, isVertical) {
  var ScrollSnapper = /*#__PURE__*/function (_Component) {
    _inherits(ScrollSnapper, _Component);

    var _super = _createSuper(ScrollSnapper);

    function ScrollSnapper(props) {
      var _this;

      _classCallCheck(this, ScrollSnapper);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "setObservers", function () {
        if (_this.observer) {
          _this.observer.disconnect();
        }

        var scroller = _this.scrollerRef.current;

        if (scroller) {
          var threshold = [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0];
          _this.observer = new IntersectionObserver(_this.onChildIntersect, {
            threshold: threshold
          });
          Array.from(scroller.children).forEach(function (child) {
            return _this.observer.observe(child);
          });
        }
      });

      _defineProperty(_assertThisInitialized(_this), "onChildIntersect", function (entries) {
        if (!_this.scrollerRef.current) {
          return;
        }

        var currentIndex = _this.state.index;
        entries.forEach(function (entry) {
          var boundingClientRect = entry.boundingClientRect,
              isIntersecting = entry.isIntersecting,
              intersectionRatio = entry.intersectionRatio,
              target = entry.target;
          var width = boundingClientRect.width;
          var index = Array.prototype.indexOf.call(_this.scrollerRef.current.children, target);
          var inBounds = isIntersecting && intersectionRatio > 0.58 && width > 0;
          var isCurrentIndex = index === currentIndex;
          var shouldUpdate = inBounds && !isCurrentIndex;

          if (shouldUpdate) {
            _this.setState({
              index: index
            });
          }
        });
      });

      _defineProperty(_assertThisInitialized(_this), "getChild", function () {
        var scroller = _this.scrollerRef.current;

        if (!scroller) {
          return false;
        }

        if (!_this.scrollChild) {
          _this.scrollChild = scroller.querySelector(".".concat(css.child));
        }

        return _this.scrollChild;
      });

      _defineProperty(_assertThisInitialized(_this), "goTo", function (index) {
        var onScrollComplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
        var noDelay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var newIndex = Math.max(index, 0);

        var scrollChild = _this.getChild();

        if (!scrollChild) {
          return false;
        }

        var scrollChildOffset = (isVertical ? scrollChild.offsetHeight : scrollChild.offsetWidth) || 0;
        var scrollTo = scrollChildOffset * newIndex;

        _this.scrollTo(scrollTo, onScrollComplete, noDelay);

        _this.setState({
          index: newIndex
        });

        return true;
      });

      _defineProperty(_assertThisInitialized(_this), "scrollTo", function (scrollTo) {
        var onComplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
        var noDelay = arguments.length > 2 ? arguments[2] : undefined;
        var scroller = _this.scrollerRef.current;

        if (!scroller || !scroller.scrollTo) {
          return;
        }

        if (noDelay) {
          scroller.scrollTo(isVertical ? 0 : scrollTo, isVertical ? scrollTo : 0);
        }

        scroller.scrollTo(isVertical ? {
          top: scrollTo,
          behavior: 'smooth'
        } : {
          left: scrollTo,
          behavior: 'smooth'
        });
        onComplete();
      });

      _defineProperty(_assertThisInitialized(_this), "toggleClasses", function (shouldAdd) {
        var parentDirectionClass = isVertical ? css.parentY : css.parentX;
        var parentClass = !shouldAdd ? '' : parentDirectionClass;
        var childClass = !shouldAdd ? '' : css.child;

        _this.setState({
          childClass: childClass,
          parentClass: parentClass
        });
      });

      _defineProperty(_assertThisInitialized(_this), "resetIndex", function () {
        _this.setObservers();

        _this.scrollChild = null;

        _this.setState({
          index: 0
        });

        _this.scrollTo(0, function () {}, true);
      });

      _this.scrollerRef = /*#__PURE__*/React.createRef();
      _this.state = {
        childClass: '',
        index: 0,
        parentClass: ''
      };
      return _this;
    }

    _createClass(ScrollSnapper, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.toggleClasses(true);
        this.setObservers();
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state = this.state,
            childClass = _this$state.childClass,
            index = _this$state.index,
            parentClass = _this$state.parentClass;
        return /*#__PURE__*/_jsx(ChildComponent, _objectSpread(_objectSpread({}, this.props), {}, {
          childClass: childClass,
          goTo: this.goTo,
          index: index,
          parentClass: parentClass,
          resetIndex: this.resetIndex,
          scrollerRef: this.scrollerRef
        }));
      }
    }]);

    return ScrollSnapper;
  }(Component);

  return ScrollSnapper;
}

export default scrollSnapper;